<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,0.9999999403953552C12.45,0.9999999403953552,12,1.4499999403953552,12,1.9999999403953552C12,1.9999999403953552,12,6.999999940395355,12,6.999999940395355C12,6.999999940395355,4,6.999999940395355,4,6.999999940395355C4,6.999999940395355,4,1.9999999403953552,4,1.9999999403953552C4,1.4499999403953552,3.55,0.9999999403953552,3,0.9999999403953552C2.45,0.9999999403953552,2,1.4499999403953552,2,1.9999999403953552C2,1.9999999403953552,2,13.999999940395355,2,13.999999940395355C2,14.549999940395356,2.45,14.999999940395355,3,14.999999940395355C3.55,14.999999940395355,4,14.549999940395356,4,13.999999940395355C4,13.999999940395355,4,8.999999940395355,4,8.999999940395355C4,8.999999940395355,12,8.999999940395355,12,8.999999940395355C12,8.999999940395355,12,13.999999940395355,12,13.999999940395355C12,14.549999940395356,12.45,14.999999940395355,13,14.999999940395355C13.55,14.999999940395355,14,14.549999940395356,14,13.999999940395355C14,13.999999940395355,14,1.9999999403953552,14,1.9999999403953552C14,1.4499999403953552,13.55,0.9999999403953552,13,0.9999999403953552C13,0.9999999403953552,13,0.9999999403953552,13,0.9999999403953552Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Header',
} as DefineComponent
</script>
